import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';


/* import { LoginRoutes } from './login'; */
import { SelectedPickingContextProvider } from 'contexts/SelectedPickingContext';
import Totem from '../pages/Totem';


export const Routes: React.FC = () => {
  return (
    <>
      {/* <LoginRoutes /> */}
      <SelectedPickingContextProvider>
        <Switch>
          <Redirect exact from="/" to="/totem" />
          <Route path="/totem" exact component={Totem} />
          <Redirect to="/totem" />
        </Switch>
      </SelectedPickingContextProvider>
    </>
  );
};
